import { mime } from '@quintoandar/cozy-utils/helpers/nativeBridge';
import PropTypes from 'prop-types';
import React from 'react';
import UploadInputLabel from './UploadInputLabel';
import UploadInputWrapper from './UploadInputWrapper';

export const ChooseFile = ({
  buttonName,
  handleSelectedFiles,
  enabled,
  inputType,
}) => (
  <UploadInputWrapper>
    <input
      disabled={!enabled}
      accept={mime(inputType)}
      id="uploadInput"
      onChange={(e) => handleSelectedFiles(e.target.files)}
      multiple
      type="file"
    />
    <UploadInputLabel enabled={enabled} htmlFor="uploadInput">
      {buttonName}
    </UploadInputLabel>
  </UploadInputWrapper>
);

ChooseFile.propTypes = {
  buttonName: PropTypes.string,
  handleSelectedFiles: PropTypes.func,
  enabled: PropTypes.bool,
  inputType: PropTypes.string,
};
